import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

import { AuthService } from '@app/core/auth';
import { RfqService } from '@app/core/quotes';

import { CreateClientRfqComponent } from '../create-client-rfq/create-client-rfq.component';
import { EditRfqVariantsComponent } from '../edit-rfq-variants/edit-rfq-variants.component';
import { RfqVariantSkusPopupComponent } from '../rfq-variant-skus-popup/rfq-variant-skus-popup.component';

@Component({
  selector: 'cnc-rfq-variant-skus',
  templateUrl: './rfq-variant-skus.component.html',
  styleUrls: ['./rfq-variant-skus.component.scss'],
})
export class RfqVariantSkusComponent implements OnInit {
  @Input() rfq;

  constructor(
    private modalSvc :NgbModal,
    private translate :TranslateService,
    private toastr :ToastrService,
    private rfqService :RfqService,
    private cd :ChangeDetectorRef,
    public authService :AuthService,
  ) {}

  ngOnInit() {
    if (
      this.rfq.variant_skus_count &&
      this.rfq.variant_skus_count > 0 &&
      (!this.rfq.variant_skus || this.rfq.variant_skus.length == 0)
    ) {
      this.rfq.gettingVariantSKUs = true;
      this.rfqService.getVariantSKUs(this.rfq.id).subscribe((resp) => {
        this.rfq.gettingVariantSKUs = false;
        this.rfq.variant_skus = resp;
      });
    }
  }

  editVariants() {
    const modalRef = this.modalSvc.open(EditRfqVariantsComponent, {
      size: 'lg',
    });
    modalRef.componentInstance.rfq = this.rfq;
    modalRef.result.then(
      () => {
        this.cd.detectChanges();
      },
      () => {},
    );
  }

  addVariantSku() {
    // const modalRef = this.modalSvc.open(RfqVariantSkusPopupComponent, { backdrop: "static" });
    // modalRef.componentInstance.parent = this.rfq;
    const modalRef = this.modalSvc.open(CreateClientRfqComponent, {
      size: 'lg',
      windowClass: 'xl1024',
    });
    modalRef.componentInstance.parentSku = this.rfq;
    modalRef.result.then(
      (data) => {
        if (data && data.id) {
          if (!this.rfq.variant_skus || this.rfq.variant_skus.length == 0) {
            this.rfq.variant_skus = [];
          }
          this.rfq.variant_skus.push(data);
          this.cd.detectChanges();
        }
      },
      () => {},
    );
  }

  editVariantSku(variant, idx) {
    // const modalRef = this.modalSvc.open(RfqVariantSkusPopupComponent, { backdrop: "static" });
    // modalRef.componentInstance.variant = variant;
    const modalRef = this.modalSvc.open(CreateClientRfqComponent, {
      size: 'lg',
      windowClass: 'xl1024',
    });
    variant.parent = this.rfq;
    modalRef.componentInstance.rfq = variant;
    modalRef.result.then(
      (data) => {
        if (data && data.id) {
          this.rfq.variant_skus.splice(idx, 1, Object.assign(variant, data));
          this.cd.detectChanges();
        }
      },
      () => {},
    );
  }

  delete(variant) {
    Swal.fire({
      title: this.translate.instant('MESSAGES.CONFIRM_DELETE_ROW.TITLE', {
        name: variant.product_name,
      }),
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: this.translate.instant('BUTTONS.CONFIRM_DELETE_TEXT'),
    }).then((result) => {
      if (result.value) {
        this.rfqService.deleteVariantSku(variant.id).subscribe((resp :any) => {
          this.toastr.success(
            this.translate.instant('MESSAGES.DELETE_SUCCESS.TITLE'),
            this.translate.instant('MESSAGES.DELETE_SUCCESS.TEXT'),
          );
        });
      }
    });
  }
}
